import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Inbox20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.31992 2.25C3.83235 2.25 3.38928 2.53349 3.18497 2.97618L0.365051 9.086C0.289254 9.25022 0.25 9.42894 0.25 9.60982V16.5C0.25 17.1904 0.809645 17.75 1.5 17.75H18.5C19.1904 17.75 19.75 17.1904 19.75 16.5V9.60982C19.75 9.42894 19.7107 9.25022 19.6349 9.086L16.815 2.97618C16.6107 2.53349 16.1676 2.25 15.6801 2.25H4.31992ZM2.17218 8.75L4.47987 3.75H15.5201L17.8278 8.75H14C13.8011 8.75 13.6103 8.82902 13.4697 8.96967L11.6893 10.75H8.31066L6.53033 8.96967C6.38968 8.82902 6.19891 8.75 6 8.75H2.17218ZM1.75 10.25V16.25H18.25V10.25H14.3107L12.5303 12.0303C12.3897 12.171 12.1989 12.25 12 12.25H8C7.80109 12.25 7.61032 12.171 7.46967 12.0303L5.68934 10.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Inbox20.displayName = 'Inbox20';
export default Inbox20;
